import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Slider, Handles, Tracks, Rail } from 'react-compound-slider'

import Handle from './Slider/Handle'
import Track from './Slider/Track'

import { formatClassNames } from '../../utilities'

class LabeledSlider extends Component {

  render() {
    const {
      label,
      domain,
      value,
      onChange,
      showTooltips
    } = this.props

    return(
      <div
        className="labeled-slider"
        data-tip={this.props['data-tip']}
        data-multiline={this.props['data-multiline']}
        data-place={this.props['data-place']}
        data-tip-disable={!showTooltips}
      >
        <Slider
          domain={domain}
          values={[value]}
          onChange={onChange}

         >
            <div className="slider-rail" />
            <Rail>
             {({ getRailProps }) => (  // adding the rail props sets up events on the rail
               <div className="slider-rail inner" {...getRailProps()} />
             )}
            </Rail>
            <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map(handle => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    sliderDomain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks right={false}>
          {({ tracks, getTrackProps }) => (
            <div className={classnames("slider-tracks", formatClassNames(label))}>
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>
        </Slider>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    showTooltips: state.editorPreferences.showTooltips
  }
}

export default connect(mapStateToProps, null)(LabeledSlider)
